<template>
  <div class="DetailsAdminSection">
    <box :title="$t('DetailsAdminSection')">
      <div class="pa-3">
        <v-row>
          <v-col sm="6">
            <div class="d-flex">
              <label class="center ml-2">{{ $t("changeAdmin") }}: </label>
              <!-- <v-text-field solo v-model="perno" hide-details=""></v-text-field> -->
              <v-text-field solo v-model="pernoText" hide-details=""></v-text-field>
            </div>
            <div class="d-flex mt-2">
              <label class="center ml-2">{{ $t("changeGroup") }}: </label>
              <v-select
                hide-details
                v-model="sectionType"
                :items="sectionTypes"
                :label="$t('sectionType')"
                item-text="Name"
                item-value="Code"
                return-object
                dense
                solo
                class="my-auto py-0"
                :disabled="isFreeOfGroupManager"
              ></v-select>
            </div>
            <div>
              <v-checkbox
                v-model="isFreeOfGroupManager"
                :label="$t('isFreeOfGroupManager')"
              />
            </div>
            <div class="d-flex mt-2">
              <label class="center ml-2">{{ $t("choosePattern") }}: </label>
              <v-select
                hide-details
                v-model="selectedPattern"
                :items="patternList"
                :label="$t('choosePattern')"
                item-text="PatternName"
                item-value="PatternId"
                dense
                solo
                class="my-auto py-0"
              ></v-select>
            </div>
          </v-col>
        </v-row>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="deleteSection">{{
          $t("deleteSection")
        }}</v-btn>
        <v-btn color="primary" @click="changeSection">{{
          $t("changeSection")
        }}</v-btn>
        <v-btn color="primary" @click="editAdminPermission">{{
          $t("adminPermission")
        }}</v-btn>
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
export default {
  props: { sectionTypes: Array },
  computed: {
    selectedCode() {
      return this.args.id;
    },
    perno() {
      return this.args.perno;
    },
  },
  data() {
    return {
      args: {},
      patternList: [],
      selectedPattern: "",
      isFreeOfGroupManager: false,
      sectionType: {},
      sectionBeforeEdit: "",
      pernoText:"1"
    };
  },
  mounted() {},
  methods: {
    setArgs(selectedAdminArgs) {
      //debugger
      this.args = selectedAdminArgs;
      //console.log(this.args.sectionCode.toString().trim());
      this.sectionBeforeEdit = this.args.sectionCode.toString().trim();

      if (
        !this.args.sectionCode ||
        this.args.sectionCode.toString().trim() == "-1"
      ) {
        this.isFreeOfGroupManager = true;
      } else {
        this.sectionType = this.sectionTypes.find(
          (item) => item.Code == this.args.sectionCode
        );
      }

      this.GetPatternList();
    },
    GetPatternList() {
    // debugger
      this.patternList.splice(0);
      this.patternList.push({
        PatternName: this.$t("noPattern"),
        PatternId: "-1",
      });

      this.$store.dispatch("GetPatternList").then((result) => {
        ////console.log(result);
        if (result.type === ResultType.success) {
          this.patternList.push(...result.data.Table);
          this.GetPatternCode();
        }
      });
    },
    GetPatternCode() {
      //debugger
      var GetPatternCodeParams = {
        perno: this.args.perno,
        section: this.args.sectionCode,
      };
      this.$store
        .dispatch("GetPatternCode", { GetPatternCodeParams })
        .then((result) => {
          ////console.log(result);
          this.pernoText=this.args.perno;
          if (result.type === ResultType.success) {
            this.selectedPattern = Number(result.data);
          }
        });
    },
    async changeSection() {
      // debugger
      this.pernoText
      console.log("تست", this.pernoText);
      if (
        (!this.sectionType || !this.sectionType.Code) &&
        !this.isFreeOfGroupManager
      ) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.addSectionManagerGroup"),
        });
        return;
      }

      // console.log("changeSection", this.args.perno);
      console.log("changeSection", this.pernoText);
      var sectionCode = "";
      var perno = this.pernoText;
      if (!this.isFreeOfGroupManager) {
        sectionCode = this.sectionType.Code;
      } else {
        await this.$store
          .dispatch("sections/IsExistInAdminList", {
            IsExistInAdminListParams: {
              perno: perno,
              sectionCode: this.sectionBeforeEdit,
            },
          })
          .then((result) => {
            if (result.type == ResultType.success) {
              if (result.data) {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: this.$t("eosWinKartWebResource.registerdAdmin"),
                });
                return;
              } else {
                sectionCode = "-1";
              }
            }
          });
      }

      if (!perno) {
        //lblError.Text = Properties.eosWinKartWebResource.lblPrefix;
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "شماره پرسنلی خالی است",
        });
      } else {
        //debugger
        console.log(":این پرنوست" +perno)
        await this.$store
          .dispatch("sections/IsDublicatedAdmin", { perno, sectionCode })
          .then((result) => {
            ////console.log(result);
            //debugger
            if (result.type == ResultType.success) {
              if (!result.data) {
                this.UpdateSectionAdmin(sectionCode, perno, this.args.id);
              }
            }
          });

        if (this.selectedPattern != "-1") {
          var DedicatePatternParams = {
            patternId: this.selectedPattern,
            sectionid: this.args.id,
          };
          await this.$store
            .dispatch("DedicatePattern", { DedicatePatternParams })
            .then((result) => {
              ////console.log(result);
              if (result.type == ResultType.success) {
                this.$EosToast.show({
                  type: EosToastType.success,
                  msg: this.$t("operationSuccess"),
                });
                this.$emit("search");
              } else {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: this.$t("operationFailed"),
                });
              }
            });
        }

        this.$emit("search");
      }
    },
    UpdateSectionAdmin(sectionCode, perno, id) {
      //debugger
      this.$store
        .dispatch("sections/UpdateSectionAdmin", { perno, sectionCode, id })
        .then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
            this.$emit("search");
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
          }
        });
    },
    deleteSection() {
      //debugger
      //var sectionCode = this.args.sectionCode;
      var sectionCode = this.args.id;
      this.$store
        .dispatch("sections/DeleteSection", { sectionCode })
        .then((result) => {
          ////console.log(result);

          if (result.type == ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
            this.$emit("search");
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
          }
        });
    },
    editAdminPermission() {
      //debugger
      this.$router.push({
        name: "adminPermission",
        query: { id: this.args.id },
      });
    },
  },
};
</script>


<style>
</style>